<template>
  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <div class="card-title pt-3 px-3 d-flex justify-content-between">
            <div class="breadcrumb-left">
              <h4>Courses in this classroom</h4>
            </div>
          </div>
        </div>
        <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr class="px-3">
                    <th class="px-3">Title</th>
                    <th class="px-3">Total class taken</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-show="assigned_courses.length > 0" v-for="(item,index) in assigned_courses" :key="index">
                    <td>
                      <span class="font-weight-medium">
                        {{item.title}}
                      </span>
                      <div class="text-secondary mt-1 ml2">
                         <span
                             :class="item.is_optional?'badge badge-info':'badge badge-info'">{{
                             item.is_optional ? 'Optional' : 'Compulsory'
                           }}</span>
                      </div>
                      <div class="text-secondary mt-2">
                        <span class="badge badge-success ml-2">{{item.subject_code }}</span>
                      </div>

                    </td>
                    <td>
                      <span class="font-weight-medium">
                        {{item.total_class || 0}}
                      </span>
                    </td>
                  </tr>
                  <tr v-if="assigned_courses.length==0">
                    <td colspan="2" class="text-center">
                      <strong>No items found</strong>
                    </td>
                  </tr>
                </tbody>
              </table>
        <!--      <v-data-table
                  :loading="isLoading"
                  :headers="course_headers"
                  :items-per-page="20"
                  :items="assigned_courses"
              >
                <template v-slot:item.is_optional="{ item }">
                  {{item.title}}
                  <br/>
                  <span
                      :class="item.is_optional?'badge badge-info':'badge badge-info'">{{
                      item.is_optional ? 'Optional' : 'Compulsory'
                    }}</span>
                  <span class="badge badge-success ml-2">{{item.subject_code }}</span>
                </template>
                <template v-slot:item.is_taught_by_user="{ item }">
                  {{item.total_class}}
                </template>


              </v-data-table>-->
            </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        name: "class-summary-courses",
        props:['assigned_courses'],
        data() {
            return {
                course_headers: [
                  {text: 'Title', value: 'title', filterable: true, sortable: true},
                  {text: 'Total Class Taken', value: 'is_taught_by_user', filterable: false, sortable: false},
                ],
            }
        },
    }
</script>

<style scoped>

</style>
